"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogBody: function() {
        return _index.DialogBody;
    },
    dialogBodyClassNames: function() {
        return _index.dialogBodyClassNames;
    },
    renderDialogBody_unstable: function() {
        return _index.renderDialogBody_unstable;
    },
    useDialogBodyStyles_unstable: function() {
        return _index.useDialogBodyStyles_unstable;
    },
    useDialogBody_unstable: function() {
        return _index.useDialogBody_unstable;
    }
});
const _index = require("./components/DialogBody/index");
